export default {
  // apiUrl: "https://localhost:44372/api",
  //apiUrl: "https://uatapi.paratic.com.tr/api",
  //apiUrl: "https://test-api.finekra.com/api",
  apiUrl: "https://api.santiye360.com/api",
  headers: {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  },
  //demoUrl: "https://localhost:44351/",
  demoUrl: "https://test.finekra.com/",
  eInvoiceUrl: "https://api.digitalkobi.com/",
  //demoUrl: "https://www.finekra.com/",
  //frontEndUrl: "http://localhost:3000/",
  // frontEndUrl: "https://panel.paratic.com.tr/",
  //frontEndUrl: "https://ykb.finekra.com/",
  frontEndUrl: "https://test-panel.finekra.com/",
  //supportPanelImgUrl: "https://localhost:44391",
  supportPanelImgUrl: "https://yildiray-api.finekra.com",
  renderNotifications: false,
};
